"use client";

import React from "react";
import { cn } from "@/lib/utils";

const COLORS = {
  potOuter: "#C8935F",
  potInner: "#B87A45",
  trunk:    "#7A5230",
  canopyDark:  "#3F8E4F",
  canopyMid:   "#4CAF50",
  canopyLight: "#6CC469",
  messageGood: "#3F8E4F",
  messageBad:  "#C0392B",
};

export function ImpactPlant({ className = "", trend }) {
  let message;
  let messageColor;
  if (trend === "up") {
    message = "Contaminations are increasing";
    messageColor = COLORS.messageBad;
  } else {
    // 'down' and neutral/null/undefined all show the same message.
    message = "Good job reducing contaminations!";
    messageColor = COLORS.messageGood;
  }

  return (
    <div className={cn("flex items-center gap-2 select-none", className)}>
      <svg width="28" height="30" viewBox="0 0 30 34" style={{ flexShrink: 0, overflow: "visible" }}>
        <ellipse cx="15" cy="31" rx="9" ry="2.5" fill={COLORS.potOuter} />
        <path d="M9 31 L11 20 Q15 22 19 20 L21 31 Z" fill={COLORS.potInner} />

        <g className="impact-plant-stem">
          <path d="M15 20 L15 12" stroke={COLORS.trunk} strokeWidth="2.4" strokeLinecap="round" />

          <g className="impact-plant-leaf impact-plant-leaf-l">
            <circle cx="9" cy="10" r="6.5" fill={COLORS.canopyMid} />
          </g>
          <g className="impact-plant-leaf impact-plant-leaf-r">
            <circle cx="21" cy="10" r="6.5" fill={COLORS.canopyLight} />
          </g>
          <g className="impact-plant-leaf impact-plant-leaf-top">
            <circle cx="15" cy="5" r="7" fill={COLORS.canopyDark} />
          </g>
        </g>
      </svg>

      <span
        style={{
          fontSize: 12,
          fontWeight: 500,
          color: messageColor,
          whiteSpace: "nowrap",
        }}
        className="hidden lg:inline"
      >
        {message}
      </span>

      <style>{`
        .impact-plant-stem {
          transform-origin: 15px 20px;
          animation: impact-plant-wind-main 4.5s ease-in-out infinite;
        }
        .impact-plant-leaf-l {
          transform-origin: 9px 10px;
          animation: impact-plant-wind-leaf 4.5s ease-in-out infinite;
        }
        .impact-plant-leaf-r {
          transform-origin: 21px 10px;
          animation: impact-plant-wind-leaf 4.5s ease-in-out infinite 0.12s;
        }
        .impact-plant-leaf-top {
          transform-origin: 15px 5px;
          animation: impact-plant-wind-leaf 4.5s ease-in-out infinite 0.22s;
        }

        @keyframes impact-plant-wind-main {
          0%   { transform: rotate(0deg); }
          15%  { transform: rotate(4deg); }
          30%  { transform: rotate(-1deg); }
          50%  { transform: rotate(2deg); }
          65%  { transform: rotate(-3deg); }
          85%  { transform: rotate(1deg); }
          100% { transform: rotate(0deg); }
        }
        @keyframes impact-plant-wind-leaf {
          0%   { transform: rotate(0deg); }
          15%  { transform: rotate(6deg); }
          30%  { transform: rotate(-2deg); }
          50%  { transform: rotate(4deg); }
          65%  { transform: rotate(-5deg); }
          85%  { transform: rotate(2deg); }
          100% { transform: rotate(0deg); }
        }

        @media (prefers-reduced-motion: reduce) {
          .impact-plant-stem,
          .impact-plant-leaf-l,
          .impact-plant-leaf-r,
          .impact-plant-leaf-top {
            animation: none !important;
          }
        }
      `}</style>
    </div>
  );
}

export default ImpactPlant;